<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Stranke</h1>
      </div>
     
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <!--<div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            />
          </div>
          -->
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
     <div class="columnBar">
        Skriti stolpci:
              
            <multiselect
                :data-items="columns"
                :text-field="'title'"
                v-model="hiddenColumns"
             
                :data-item-key="'field'"
            />
        </div>
    <Grid  
                       
                        :sortable="sortable"
                        :filterable="filterable"
                        :groupable="groupable"
                        :pageable="pageable"
                        :data-items="dataResult"
                        :skip="skip"
                        :take="take" 
                        :sort="sort" 
                        :pageSize="pageSize"
                        :filter="filter" 
                        :columns="columns"
                        @datastatechange="dataStateChange"
                        @pagechange="pageChangeHandler"
                        
                       :resizable="true"
                        
                  
                       
                        >




                    <template v-slot:filterSlotTemplate="{props, methods}">
            <div>
              <multiselect 
                :data-items="sheme"
                :text-field="'kratica'"
                v-model="izbraneSheme"
                :data-item-key="'kratica'"
                
            />
              
              </div>
          </template>

                     <template v-slot:shemaCell="{props}">
                      <shemaCell :sheme="props.dataItem.sheme.filter(s=>(s.jeaktivna&&(s.sezona==$trenutnasezona)))"/>
                    </template>
                     <template v-slot:cbItem="{props}">
                      <cbItem :checked="props.dataItem.jeaktivna"/>
                    </template>
                        <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                     
                       
                             <button v-if="true"
                                title="Dodaj KMG"
                                class="k-button k-primary"
                                @click="dodajPridelovalca"
                            >
                                Dodaj
                            </button>
                            
                             <button
                                title="Izvozi v Excel"
                                class="k-button k-primary"
                                @click="exportExcel"
                            >
                                Izvozi v Excel
                            </button>
                           
                        </div>
                            
                        </toolbar>
                    </Grid>

                    </div>
    </div>

</template>

<script>

/*

<kendo-multiselect 
                        :data-source="columns"
                        :data-text-field="'title'"
                        :data-value-field="'field'"
                        :placeholder="'Skrij stolpce'"
                         @select="skrijStolpec"
                        @deselect="prikaziStolpec"
                        :filter="'contains'"
                        :auto-width="true"
                        :value="hiddenColumns"
                        >
            </kendo-multiselect>
*/
import { mapState, mapActions,mapMutations } from 'vuex'

import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';

import kulture from './support/kulture-data';
import { Grid, GridToolbar,GridNoRecords } from '@progress/kendo-vue-grid';
import { DropDownList, MultiSelect   } from '@progress/kendo-vue-dropdowns';
//import { saveExcel } from '@progress/kendo-vue-excel-export';
//import { MultiSelect } from '@progress/kendo-dropdowns-vue-wrapper';
import ShemaCell from './support/ShemaCell';
import CheckBoxGridItem from './support/CheckBoxGridItem';
//Vue.component('kendo-multiselect', MultiSelect);

import { process } from '@progress/kendo-data-query';
import { volumeUpIcon } from '@progress/kendo-svg-icons';



const CommandCell = Vue.component("template-component", {
    props: {
        field: String,
        dataItem: Object,
        format: String,
        className: String,
        columnIndex: Number,
        columnsCount: Number,
        rowType: String,
        level: Number,
        expanded: Boolean,
        editor: String,
        sezona: Number
    },
    computed: {
        //poglej če je group header
        //poglej če obstaja this.dataItem.field in potem this.data.items[0][field]
    /*
     <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="prikaziGerke"  title="Gerki">
                         <font-awesome-icon icon="layer-group"/>
                    </button>
                    <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediKulture" title="Kulture">
                         <font-awesome-icon icon="seedling"/>
                    </button>
                    <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediZivali" title="Živali">
                         <font-awesome-icon icon="horse-head"/>
                    </button>
                     <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediProizvode" title="Proizvodi">
                         <font-awesome-icon icon="cheese"/>
                    </button>

                    <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediCertifikat" title="Dodaj v shemo">
                         <font-awesome-icon icon="certificate"/>
                    </button>
                    <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediKontrole" title="Kontrole">
                         <font-awesome-icon icon="search-location"/>
                    </button>
                    <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediOdlocbe" title="Obrazci">
                         <font-awesome-icon icon="file-contract"/>
                    </button>
                    
    */     
    },
    template: ` <td>
     <div class="km-widget km-buttongroup k-widget k-button-group k-button-narrow">

                    <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediStranko" title="Uredi">
                         <font-awesome-icon icon="edit"/>
                    </button>

                    
                    </div>
                </td>
                `,
    methods: {
        ...mapActions('pridelava', ['select']),
        prikaziGerke: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'gerk', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem.id } })
            
        },
        urediStranko: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'dodajStranko', params: { strankaid:this.dataItem._id } })
            
        },
        urediKulture: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'kultura', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem.id } })
            
        },
          urediZivali: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'zival', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem.id } })
            
        },
          urediProizvode: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'proizvod', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem.id } })
            
        },
           urediKontrole: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'home', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem.id } })
            
        },
           urediOdlocbe: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'home', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem.id } })
            
        },
         urediCertifikat: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'home', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem.id } })
            
        }
    }
});





export default {
     props:["sezona"],
      components:{
      'dropdownlist': DropDownList,
      'multiselect': MultiSelect, 
      'shemaCell': ShemaCell,
      'cbItem': CheckBoxGridItem,
  //    'sifkontroleddcell': SifrantKontroleDownCell,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
 
  },
    data () {
        return {
            dataSezona:this.sezona,
            valIzbraneSheme:[],
          
           
            girdDataApi:null,
            gridData:null,


             
            editID: null,
            skip: 0,
            take: 10,
            pageSize: 10,
            sortable: true,
            filterable: true,
            groupable: false,
            
            expandedItems: [],
            dataResult: [],
         
            sort: [
                { field: 'ime', dir: 'asc' }
            ],
           columns:[
                { title: "Ukazi", cell: CommandCell,filterable:false,columnMenu: null,width:"50px",sortable:false},
                { field: "naziv", title:"Naziv"},
                { field: "kmgmid", title:"KMG-MID",hidden:true},
                //{ field: "kontrolnastevilka", title:"Kontrolna št."},
                { field: "naslov", title:"Naslov",},
                { field: "postnastevilka", title:"Poštna št."},
                { field: "posta", title:"Pošta"},
                { field: "obcina", title:"Občina",hidden:true},
                //{ field: "statisticnaregija", title:"Statistična regija KMG"},
                //{ field: "naslovnosilca", title:"Naslov nosilca",hidden:true},
                //{ field: "postnastevilkanosilca", title:"Poštna št. nosilca",hidden:true},
                //{ field: "postanosilca", title:"Pošta nosilca",hidden:true},
                //{ field: "statuspridelovalca", title:"Status"},
                //{ field: "datumdolocitvestatusa", title:"Datum določitve statusa", filterable:false, type:"date",format: '{0:d}', hidden:true},
                { field: "davcnastevilka", title:"Davčna številka",hidden:true},
                { field: "mso", title:"MŠO",hidden:true},
                { field: "maticnaStranka", title:"Matično podjetje",hidden:true},
                //{ field: "vrstaPridelovalca", title:"Vrsta pridelovalca",hidden:true},
                //{ field: "imavezanezivali", title:"Vezana reja",hidden:true},
                //{ field: "imatravojedezivali", title:"Travojede živali",hidden:true},
                { field: "sheme", title:"Aktivne sheme",cell:"shemaCell",filterCell: 'filterSlotTemplate'},
                { field: "jeaktivna", title:"V kontroli",cell:"cbItem", hidden:true},
                
            ],

           

        }
    },
    created () {

         
      if(!this.sezona)
        this.dataSezona={sezona:this.$trenutnasezona};
      else
      this.dataSezona={sezona:this.sezona};

        
            


        
    
     this.load(this.dataSezona).then(d=>{

        d.forEach(i=>{
            Vue.set(i,"jeaktivna",i.sheme.find(s=>(s.jeaktivna&&(s.sezona==this.$trenutnasezona)))?true:false);
            
        })

     });
     
     this.filter={
                logic: "and",
                filters: [
                    { field: "jeaktivna", operator: "neq", value: 0}
                ]
            };


    },
    computed: {

        pageable(){
            return { buttonCount: 4, pageSizes: [10,100,this.pridelavasheme?.length] }
        },
        pridelavasheme:{
            get(){

                if(!this.pridelava)
                    return []
                else 
                    return this.pridelava.filter(
                            p=>{

                                for (const f of this.valIzbraneSheme)
                                {
                                    if(p.sheme?.find(s=>s.shema==f.kratica&&s.jeaktivna&&s.sezona==this.$trenutnasezona))
                                            return true;
                                }
                                if(this.valIzbraneSheme.length<1)
                                    return true;

                                return false;

                            }
                        )

            }

        },
        filter:{
            get(){
                return this.storedfilter;
            },
            set(value){
                this.updatefilter(value);
            }
        },
        ...mapState('pridelava', ['pridelava','storedfilter']),
        ...mapState('users', ['userDetails','sezonePisanje','sheme']),

        izbraneSheme:{
            get(){
                    return this.valIzbraneSheme;
            },
            set(value){
                
                //odstrani vse sheme
               
                this.valIzbraneSheme=value;

               


                 const dataState = {
                            skip: this.skip,
                            take: this.take,
                            filter: this.filter,
                            sort: this.sort,
                        };
                    this.dataResult = process( this.pridelavasheme, dataState);      
            }

        },

        hiddenColumns: {

            get() {
                    return this.columns.filter(c=>c.hidden);
            },
            set(e){
              

        this.columns.forEach(c=>{
                if(e.find(i=>i.field==c.field)){
                    Vue.set(c,'hidden',true);
                }
                else
                    Vue.set(c,'hidden',false);
        })
        const dataState = {
            skip: this.skip,
            take: this.take,
             filter: this.filter,
            sort: this.sort,
            
        };
        this.dataResult = process( this.pridelavasheme, dataState);
            }
        },
/*        columns() {

            let columns=[
                
                { field: "naziv", title:"Naziv"},
                { field: "kmgmid", title:"KMG-MID",hidden:true},
                //{ field: "kontrolnastevilka", title:"Kontrolna št."},
                { field: "naslov", title:"Naslov",},
                { field: "postnastevilka", title:"Poštna št."},
                { field: "posta", title:"Pošta"},
                { field: "obcina", title:"Občina",hidden:true},
                //{ field: "statisticnaregija", title:"Statistična regija KMG"},
                //{ field: "naslovnosilca", title:"Naslov nosilca",hidden:true},
                //{ field: "postnastevilkanosilca", title:"Poštna št. nosilca",hidden:true},
                //{ field: "postanosilca", title:"Pošta nosilca",hidden:true},
                //{ field: "statuspridelovalca", title:"Status"},
                //{ field: "datumdolocitvestatusa", title:"Datum določitve statusa", filterable:false, type:"date",format: '{0:d}', hidden:true},
                { field: "davcnastevilka", title:"Davčna številka",hidden:true},
                { field: "mso", title:"MŠO",hidden:true},
                //{ field: "vrstaPridelovalca", title:"Vrsta pridelovalca",hidden:true},
                //{ field: "imavezanezivali", title:"Vezana reja",hidden:true},
                //{ field: "imatravojedezivali", title:"Travojede živali",hidden:true},
                { field: "sheme", title:"Sheme",cell:"shemaCell",filterCell: 'filterSlotTemplate'},
                { field: "jeaktivna", title:"V kontroli",cell:"cbItem", hidden:true},
                
            ];

            if(this.userDetails.pravice.includes("STRANKE_PISI"))
                columns.unshift({ title: "Ukazi", cell: CommandCell,filterable:false,columnMenu: null,width:"130px",sortable:false});

            if(this.userDetails.pravice.includes("STATISTIKA_BERI"))
                columns.push({ field: "kontrolnaorganizacija", title:"V kontroli pri"});




            return columns;


        }*/

           },
      watch: {
        skip(newValue, oldValue){
           

            const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
          
        };
        this.dataResult = process( this.pridelavasheme, dataState);
        },
        take(newValue, oldValue){
         
       /*  if(isNaN(this.take))
            this.take=this.pridelava.length;
         */   
            const dataState = {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                 filter: this.filter,
                
            }
        this.dataResult = process( this.pridelavasheme, dataState);
        },
       pridelava(newValue, oldValue) {
    

      if(newValue){
        const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            
        };
        this.dataResult = process( this.pridelavasheme, dataState);
        }
    }
},
    methods: {

        ...mapActions('pridelava', ['load','replace']),
        ...mapMutations('pridelava',['updatefilter']),


        filtrirajStolpce(e) {
                console.log("filtriram!!!");
                console.log(e);

        this.columns.forEach(c=>{
                if(e.value.find(i=>i.field==c.field)){
                    console.log("skrivam "+c.field);
                    c.hidden=true;
                }
                else
                    c.hidden=false;
        })
        console.log(this.columns);
        console.log(this.hiddenColumns);
        const dataState = {
            skip: this.skip,
            take: this.take,
             filter: this.filter,
            sort: this.sort,
            
        };
        this.dataResult = process( this.pridelavasheme, dataState);

        },
        filtrirajShemo() {


        },
         skrijStolpec: function(e) {
            let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=true;
                const dataState = {
            skip: this.skip,
            take: this.take,
             filter: this.filter,
            sort: this.sort,

        };
        this.dataResult = process( this.pridelavasheme, dataState);
           
        },
        
        filterChange: function(ev) {
            this.filter = ev.filter;
        },

        prikaziStolpec: function(e) {
           let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=false;
                const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            
        };
        this.dataResult = process( this.pridelavasheme, dataState);
        },
        sezonaChange(event) {
            const sezona = event.value;
            this.$router.push({ name: 'stranke', params: { sezona:sezona.sezona} })
            this.dataSezona=sezona;
            this.load({sezona:this.dataSezona.sezona});
            
     


        },

        
        createAppState: function(dataState) {
           
            this.take = dataState.take;
            this.skip = dataState.skip?dataState.skip:0;
            this.filter = dataState.filter;
            this.sort = dataState.sort;
           
        },

        dataStateChange (event) {
            this.createAppState(event.data);
           
            this.dataResult = process(this.pridelavasheme, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,

            });
          

        },
        formatDate: function (h, emptyElement , props, listeners ) {
          
             return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
        dodajPridelovalca(){

              this.$router.push({ name: 'dodajStranko'})

        },
        exportExcel () {
            
            this.saveExcel({
                data: process(this.pridelavasheme, {
                
                sort: this.sort,
                filter: this.filter,
                
            }).data,
                fileName:this.dataSezona.sezona+ "_PRIDELOVALCI",
                columns: this.columns.filter(i=>!i.hidden)
            });
        },

         pageChangeHandler: function(event) {
            
            this.skip = event.page.skip;
            this.take = event.page.take;
           
        },
        filterchange: function(ev) {

            this.updatefilter(ev);
            console.log(ev);
        },
        
    }
};
</script>

